import React from 'react'

function NotHealthy() {
  return (
    <>
      <div className='notHealthy'>NotHealthy</div>
      <h2 className='warning'>COMING SOON</h2>
    </>
  )
}

export default NotHealthy